export default "__VITE_ASSET__jlLpPkRL__"